import { AJUDA_ARQUIVOS } from "@/lib/ajuda/dialogos/arquivos";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { formatFileDate } from "@/lib/files-format";

const ACTION_LABELS: Record<string, string> = {
  UPLOAD: "Enviou o arquivo",
  DOWNLOAD: "Baixou o arquivo",
  RENAME: "Renomeou o arquivo",
  MOVE: "Moveu o arquivo",
  DELETE: "Excluiu o arquivo",
  SHARE: "Compartilhou o arquivo",
  UNSHARE: "Revogou um compartilhamento",
  NEW_VERSION: "Enviou uma nova versão",
};

export function FileHistoryDialog({ fileId, onClose }: { fileId: string | null; onClose: () => void }) {
  const activityQuery = trpc.file.listActivity.useQuery({ fileId: fileId ?? "" }, { enabled: !!fileId });
  const activity = activityQuery.data ?? [];

  return (
    <Dialog open={!!fileId} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md bg-white dark:bg-card">
        <DialogHeader>
          <DialogTitle ajuda={AJUDA_ARQUIVOS.historico}>Histórico</DialogTitle>
        </DialogHeader>

        {activityQuery.isLoading ? (
          <div className="flex justify-center py-6">
            <Loader2 className="h-5 w-5 animate-spin text-brand-600" />
          </div>
        ) : activity.length === 0 ? (
          <p className="py-6 text-center text-sm text-zinc-400 dark:text-muted-foreground">
            Nenhuma atividade registrada ainda.
          </p>
        ) : (
          <ul className="max-h-96 space-y-3 overflow-y-auto">
            {activity.map((entry) => (
              <li key={entry.id} className="flex items-start justify-between gap-3 border-b border-zinc-100 pb-3 last:border-b-0 last:pb-0 dark:border-border/50">
                <div className="min-w-0">
                  <p className="text-sm font-medium text-zinc-900 dark:text-foreground">
                    {ACTION_LABELS[entry.action] ?? entry.action}
                  </p>
                  <p className="text-xs text-zinc-500 dark:text-muted-foreground">
                    {entry.user?.name ?? "Link público"}
                  </p>
                </div>
                <span className="shrink-0 text-xs text-zinc-400 dark:text-muted-foreground">
                  {formatFileDate(entry.createdAt)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
